import React from "react";
import MotionButton from "../MotionButton";

function NavigationButton({
  children,
  style = {},
  ...props
}) {
  return (
    <MotionButton
      variant="navigation"
      style={style}
      {...props}
    >
      {children}
    </MotionButton>
  );
}

export default NavigationButton;